import { isEmpty } from 'lodash-es';
import qs from 'qs';
import { LOCALE } from '@/utils';

(() => {
  const { search } = window.location;
  const { locale, ...rest } = qs.parse(search, { ignoreQueryPrefix: true });
  if (locale && typeof locale === 'string') {
    LOCALE.setLocale(locale as string);
    const url = `${window.location.pathname}${
      rest && !isEmpty(rest) ? '?' : ''
    }${qs.stringify(rest)}`;
    window.history.replaceState({}, '', url);
    return;
  }
  const storageLocale = LOCALE.getLocale();
  if (storageLocale && ['zh_CN', 'en_US'].includes(storageLocale)) return;
  let browserLocale: string;
  const isNavigatorLanguageValid =
    typeof navigator !== 'undefined' && typeof navigator.language === 'string';
  browserLocale = isNavigatorLanguageValid
    ? navigator.language.split('-').join('_')
    : '';
  const finallyLocale = ['zh_CN', 'en_US'].includes(browserLocale)
    ? browserLocale
    : 'zh_CN';
  LOCALE.setLocale(finallyLocale);
})();
